import { Form, useFormState } from 'react-final-form';
import FormContent from './FormContent';
import { type CategoriesLimits } from 'src/old/api/flexflow/types';
import { useDispatch } from 'react-redux';
import { putFlexflowCategoryLimits } from 'src/old/actions';
import { type FlexflowLimits } from 'src/modules/Flexflow/Contracts/types';

type CategoriesGroupFormProps = {
  currencySymbol: string;
  monthlyTotalLimit: number;
};

const defaultFutureLimitsOrCurrent = (employeeLimits?: FlexflowLimits) => {
  const foodLimit = employeeLimits?.foodLimit;
  const transportLimit = employeeLimits?.transportLimit;

  return { foodLimit, transportLimit };
};

const CategoriesGroupForm = ({ currencySymbol, monthlyTotalLimit }: CategoriesGroupFormProps) => {
  const { values } = useFormState();
  const defaultLimits = defaultFutureLimitsOrCurrent(values?.limits);
  const dispatch = useDispatch();

  const handleSubmit = async (limits: CategoriesLimits) => {
    await putFlexflowCategoryLimits(values.payflowUserId || values.id, limits)(dispatch);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={defaultLimits}
      render={({ form: { submit } }) => {
        return (
          <FormContent
            submit={submit}
            currencySymbol={currencySymbol}
            monthlyTotalLimit={monthlyTotalLimit}
            employeeLimits={values.limits}
          />
        );
      }}
    />
  );
};

export default CategoriesGroupForm;
